/**
 * Shadow Board Configurator – Cart Preview
 * Ersetzt Standard-Produktbilder im Warenkorb durch das konfigurierte Design.
 *
 * Funktioniert über localStorage: Der Konfigurator speichert dort
 * ein Preview-Bild pro Design-ID. Dieses Script liest die Design-IDs
 * aus den Warenkorb-Zeilen und tauscht die Bilder aus.
 */

(function () {
  'use strict';

  var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
  var hasCartDrawer = Boolean(document.querySelector('cart-drawer, #CartDrawer'));
  if (!isCartPage && !hasCartDrawer) return;

  function replacePreviews() {
    // Previews aus localStorage laden
    var previews = {};
    try {
      previews = JSON.parse(localStorage.getItem('sbc_previews') || '{}');
    } catch (e) { return; }

    if (Object.keys(previews).length === 0) return;

    // Shopify Cart API abfragen für Design-IDs
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) return;

        cart.items.forEach(function (item, index) {
          var designId = null;
          var props = item.properties;

          if (!props) return;

          // Priority lookup: _Cart_ID first, fallback to _Design_ID
          if (props['_Cart_ID']) {
            designId = props['_Cart_ID'];
          } else if (props['_Design_ID']) {
            designId = props['_Design_ID'];
          }

          // 1. LocalStorage (Höchste Prio, sofort da)
          // 2. Backend URL (Perfekte Qualität, leicht verzögert)
          // 3. Fallback Data-URL (Winzig)
          var previewUrl = previews[designId] || props['_Preview_Image'] || props['_preview'] || (props['_preview_1'] && props['_preview_2'] ? props['_preview_1'] + props['_preview_2'] : null);

          if (!previewUrl) return;

          // Alle möglichen Cart-Image-Selektoren versuchen (verschiedene Themes)
          var selectors = [
            // Standard Shopify Themes
            '.cart-item__image img',
            '.cart__image img',
            '.cart-item__media img',
            // Enterprise Theme
            '.cart__table-row img.cart__image',
            'tr .cart__image-wrapper img',
            // Dawn Theme
            '.cart-item__image-container img',
            // Generisch
            '[data-cart-item-index="' + (index + 1) + '"] img',
            'td.cart-item__media img',
            // Fallback: alle Bilder in Cart-Zeilen
            '.cart__items .cart-item img[src*="cdn.shopify.com"]',
            '.cart-items .cart-item img[src*="cdn.shopify.com"]'
          ];

          // Versuche Bilder über den Item-Key/URL zu finden
          var allCartImages = document.querySelectorAll(
            '.cart img[src*="cdn.shopify.com"], ' +
            '[class*="cart"] img[src*="cdn.shopify.com"], ' +
            'form[action="/cart"] img[src*="cdn.shopify.com"]'
          );

          // Index-basierter Ansatz: das n-te Produktbild im Cart ersetzen
          var productImages = [];
          allCartImages.forEach(function (img) {
            // Nur Produktbilder (nicht Icons, Logos etc.)
            if (img.width >= 50 || img.naturalWidth >= 50 || img.getAttribute('width') >= 50) {
              productImages.push(img);
            }
          });

          if (productImages[index] && !productImages[index].dataset.sbcReplaced) {
            var img = productImages[index];
            img.src = previewUrl;
            img.srcset = '';
            img.removeAttribute('srcset');
            img.style.objectFit = 'contain';
            img.style.backgroundColor = '#fff';
            img.dataset.sbcReplaced = '1';
            console.log('[SBC] Cart-Preview ersetzt für Design:', designId);
          }
        });
      })
      .catch(function (err) {
        console.warn('[SBC] Cart-Preview Fehler:', err);
      });
  }

  // Warten bis DOM geladen, dann ausführen
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Kurz warten bis Cart-Bilder gerendert sind
      setTimeout(replacePreviews, 500);
    });
  } else {
    setTimeout(replacePreviews, 500);
  }

  // Auch nach AJAX-Updates erneut versuchen (für dynamische Carts)
  var observer = new MutationObserver(function (mutations) {
    var hasRelevantChange = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (hasRelevantChange) {
      setTimeout(replacePreviews, 300);
    }
  });

  var cartContainer = document.querySelector(
    'cart-drawer, #CartDrawer, main-cart-items, [class*="cart"], form[action="/cart"]'
  );
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true });
  }

})();
